// import store from "@/store"
// import router from "@/router/index";


const AttendanceNotification = (socket) => {
    // if(section ) return;
    // socket.listenEvent('Monitoring\\AttendanceNotification', async (response) => {
    //     console.log(response);
    // });
}

export { AttendanceNotification }